import { Widget } from '~/components/ui/dashboard/widgetSchemas';
import { AgentChatMessage } from '../types';

export const parseRawWidgetIds = (
  widgetIds: AgentChatMessage['widget_ids'],
  isAggregate?: boolean,
): Widget[] => {
  if (!widgetIds) {
    return [];
  }

  return widgetIds?.map((id) => {
    if (typeof id === 'string') {
      return {
        id: crypto.randomUUID(),
        name: id,
      };
    }

    return {
      id: crypto.randomUUID(),
      name: 'dynamic' as const,
      metadata: {
        renderComponent: id.type,
        query: id.query,
        shortDescription: id.short_description,
        isAggregate: id.is_aggregate ?? isAggregate ?? false,
      },
    };
  });
};
